<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
  @import './common/less/index.less';
</style>



// WEBPACK FOOTER //
// App.vue?b0496e38